<script setup lang="ts">
const el = ref()
const v = useElementVisibility(el)
</script>

<template>
  <div ref="el" relative h-496px w-full>
    <svg
      :class="v && 'animated-fade-in-left'"
      absolute animated class="left-[clamp(-10000px,calc((100vw-1920px)/2.2+0px),0px)]" xmlns="http://www.w3.org/2000/svg" width="1131" height="496" viewBox="0 0 1131 496" fill="none"
    >
      <path d="M0 0H1131L788.5 496H0V0Z" fill="#CE0000" />
    </svg>

    <div absolute bottom-20px container col items-center justify-center md:inset-0>
      <div>
        <p class="text-35px font-bold lh-100% md:text-80px" :class="v && 'animated-fade-in-left'" animated animated-delay-200>
          ACQUIRE ROMA
        </p>
        <p :class="v && 'animated-fade-in-left'" mt-20px text-24px font-bold animated animated-delay-300 md:text-53px>
          STEP 1
        </p>
        <p :class="v && 'animated-fade-in-left'" mt-14px text-24px font-bold animated animated-delay-400 lt-md:text-15px>
          You can obtain ROMA in two ways:
        </p>

        <div :class="v && 'animated-fade-in-left'" mt-20px max-w-293px animated animated-delay-500 md:hidden>
          <p text-24px font-bold>
            STAKING
          </p>
          <p mt-14px text-15px font-bold>
            Stake any token with liquidity for 7, 14, or 30 days to receive ROMA.
          </p>

          <p my-20px text-35px font-bold>
            OR
          </p>

          <p text-24px font-bold>
            BUYING
          </p>
          <p mt-14px text-15px font-bold>
            Directly purchase ROMA from the missweb3.org website.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div mt-40px row items-center justify-center px-2rem lt-md:hidden>
    <div max-w-480px>
      <p text-53px font-bold>
        STAKING
      </p>
      <p text-24px font-bold>
        Stake any token with liquidity for 7, 14, or 30 days to receive ROMA.
      </p>
    </div>
    <span class="lh-100%" mx-40px text-35px font-bold>
      or
    </span>
    <div max-w-480px>
      <p text-53px font-bold>
        BUYING
      </p>
      <p text-24px font-bold>
        Directly purchase ROMA from the missweb3.org website.
      </p>
    </div>
  </div>
</template>

<style scoped>

</style>
